import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { ApiResponse } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

export const useDeleteSite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.sites.deleteSite],
    mutationFn: async (siteId: string): Promise<void> => {
      await XHRAuthorizedClient.delete<ApiResponse<void>>(
        ENDPOINTS.sites.delete(siteId)
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('사이트 삭제 오류:', error);
    },
  });
};
